let nextSessionGenerationId = 0;
let activeSessionGenerationId = 0;
let tokenBoundGeneration: { token: string; generationId: number } | null = null;

export function beginSessionGeneration(): number {
    nextSessionGenerationId += 1;
    activeSessionGenerationId = nextSessionGenerationId;
    return activeSessionGenerationId;
}

export function resolveGenerationForToken(token: string, forceNew = false): number {
    if (!forceNew && tokenBoundGeneration?.token === token) {
        activeSessionGenerationId = tokenBoundGeneration.generationId;
        return tokenBoundGeneration.generationId;
    }
    const generationId = beginSessionGeneration();
    tokenBoundGeneration = { token, generationId };
    return generationId;
}

export function clearTokenGeneration(token?: string): void {
    if (!token || tokenBoundGeneration?.token === token) {
        tokenBoundGeneration = null;
    }
}

export function getActiveSessionGenerationId(): number {
    return activeSessionGenerationId;
}

export function isActiveSessionGeneration(generationId: number): boolean {
    return generationId === activeSessionGenerationId;
}

export function resetSessionGenerationForTests(): void {
    nextSessionGenerationId = 0;
    activeSessionGenerationId = 0;
    tokenBoundGeneration = null;
}
